import type { AccountTransfer } from '../types';

/** Returns true if a transfer is between two accounts the user owns. */
export const isInternalTransfer = (
    transfer: AccountTransfer,
    accountIds: string[],
): boolean =>
    accountIds.includes(transfer.source) && accountIds.includes(transfer.target);
